import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6733c8b9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "certer"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", null, null, -1));
const _hoisted_5 = {
  class: "certer"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, "       基金销售服务由上海长量基金销售有限公司提供，长量为中国证监会批准的第三方独立基金销售机构，基金销售资格证书编号：00000000794。投资人应详细阅读产品合同、说明书、风险揭示书等法律文件及相关公告，独立做出投资决策，自行承担投资风险。", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, "       绿城财富平台作为信息服务平台，不对任何投资人或任何交易提供任何形式的担保，不构成任何投资建议或承诺。市场有风险，投资需谨慎！", -1));
const _hoisted_8 = {
  class: "btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.logoImg
  }, null, 8, _hoisted_3), _hoisted_4]), _createElementVNode("h2", _hoisted_5, "即将跳转至长量页面… " + _toDisplayString($data.count), 1), _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => $options.clickJump())
  }, "点击前往")])]);
}